function dropdown() {
  const mediaQuery = window.matchMedia('(max-width: 767px)');

  const head = document.getElementById('gh-navigation') || document.querySelector('.gh-navigation');
  if (!head) return;

  const menu    = head.querySelector('.gh-navigation-menu');
  const inner   = head.querySelector('.gh-navigation-inner');
  const actions = head.querySelector('.gh-navigation-actions');
  if (!menu || !inner || !actions) return;

  const nav = menu.querySelector('.nav');
  if (!nav) return;

  const logo = document.querySelector('.gh-navigation-logo');
  const navHTML = nav.innerHTML;

  if (mediaQuery.matches) {
    const items = nav.querySelectorAll('li');
    items.forEach((item, index) => {
      item.style.transitionDelay = `${0.03 * (index + 1)}s`;
    });
  }

  let currentWrapper = null;
  let currentToggle  = null;
  let isDesktopInit  = false;
  let isMobileInit   = false;

  const makeDropdown = function () {
    if (mediaQuery.matches) return;

    currentWrapper = null;
    currentToggle  = null;

    const list = menu.querySelector('.nav');
    if (!list) return;

    const submenuItems = [];
    while ((list.offsetWidth + 64) > menu.offsetWidth) {
      if (list.lastElementChild) {
        submenuItems.unshift(list.lastElementChild);
        list.lastElementChild.remove();
      } else {
        break;
      }
    }

    if (!submenuItems.length) {
      head.classList.add('is-dropdown-loaded');
      return;
    }

    const toggle = document.createElement('button');
    toggle.setAttribute('class', 'gh-more-toggle gh-icon-button');
    toggle.setAttribute('aria-label', 'More');
    toggle.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
        <path d="M21.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194
                 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473
                 0-2.667-1.194-2.667-2.667v0zM13.333 16c0-1.473
                 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194
                 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473
                 0-2.667-1.194-2.667-2.667v0zM5.333 16c0-1.473
                 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194
                 2.667 2.667v0c0 1.473-1.194 2.667-2.667
                 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0z"></path>
      </svg>`;

    const wrapper = document.createElement('div');
    wrapper.className = 'gh-dropdown is-portal';

    const listEl = document.createElement('ul');
    if (submenuItems.length >= 10) {
      head.classList.add('is-dropdown-mega');
      wrapper.style.gridTemplateRows = `repeat(${Math.ceil(submenuItems.length / 2)}, 1fr)`;
    } else {
      head.classList.remove('is-dropdown-mega');
    }

    submenuItems.forEach(child => listEl.appendChild(child));
    wrapper.appendChild(listEl);
    toggle.appendChild(wrapper);
    list.appendChild(toggle);
    document.body.appendChild(wrapper);

    const toggleRect = toggle.getBoundingClientRect();
    if (toggleRect.left < window.innerWidth / 2) {
      wrapper.classList.add('is-left');
    }
    head.classList.add('is-dropdown-loaded');

    function positionDropdown() {
      const rect = toggle.getBoundingClientRect();
      const gutter = 8;
      const preferLeft = wrapper.classList.contains('is-left');
      const prevVis = wrapper.style.visibility;
      const wasOpen = wrapper.classList.contains('is-open');
      wrapper.style.visibility = 'hidden';
      wrapper.classList.add('is-open');
      const panelWidth = wrapper.offsetWidth || 200;
      if (!wasOpen) wrapper.classList.remove('is-open');
      wrapper.style.visibility = prevVis;
      const top = Math.round(rect.bottom + gutter);
      let left = Math.round(preferLeft ? rect.left : rect.right - panelWidth);
      left = Math.max(8, Math.min(left, window.innerWidth - panelWidth - 8));
      wrapper.style.top  = `${top}px`;
      wrapper.style.left = `${left}px`;
    }

    function openDropdown() {
      head.classList.add('is-dropdown-open');
      wrapper.classList.add('is-open');
      positionDropdown();
      window.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener('resize', handleResize);
    }

    function closeDropdown() {
      head.classList.remove('is-dropdown-open');
      wrapper.classList.remove('is-open');
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    }

    function handleScroll() {
      if (wrapper.classList.contains('is-open')) positionDropdown();
    }

    function handleResize() {
      if (wrapper.classList.contains('is-open')) closeDropdown();
    }

    window.addEventListener('click', function (e) {
      if (wrapper.contains(e.target)) return;
      if (toggle.contains(e.target)) {
        if (wrapper.classList.contains('is-open')) closeDropdown();
        else openDropdown();
      } else {
        closeDropdown();
      }
    });

    currentWrapper = wrapper;
    currentToggle  = toggle;
  };

  function teardownDesktopDropdown() {
    if (currentWrapper && currentWrapper.parentNode) currentWrapper.parentNode.removeChild(currentWrapper);
    if (currentToggle && currentToggle.parentNode)   currentToggle.parentNode.removeChild(currentToggle);
    head.classList.remove('is-dropdown-loaded', 'is-dropdown-open', 'is-dropdown-mega');
    currentWrapper = null;
    currentToggle  = null;
  }

  function initDesktop() {
    if (isDesktopInit) return;
    isDesktopInit = true;

    // unwrap mobile panel if present
    unwrapMobilePanel();

    nav.innerHTML = navHTML;

    if (typeof imagesLoaded === 'function' && logo) {
      imagesLoaded(logo, makeDropdown);
    } else if (document.readyState === 'complete') {
      makeDropdown();
    } else {
      window.addEventListener('load', makeDropdown, { once: true });
    }

    const desktopRebuild = () => {
      if (mediaQuery.matches) return;
      if (currentWrapper && currentWrapper.classList.contains('is-open')) {
        currentWrapper.classList.remove('is-open');
        head.classList.remove('is-dropdown-open');
      }
      const l = menu.querySelector('.nav');
      if (l) l.innerHTML = navHTML;
      makeDropdown();
    };

    let resizeTimeout = null;
    const onResize = () => {
      if (mediaQuery.matches) return;
      window.clearTimeout(resizeTimeout);
      resizeTimeout = window.setTimeout(desktopRebuild, 1);
    };

    initDesktop._onResize = onResize;
    window.addEventListener('resize', onResize);
  }

  function teardownDesktop() {
    if (!isDesktopInit) return;
    isDesktopInit = false;
    teardownDesktopDropdown();
    if (initDesktop._onResize) {
      window.removeEventListener('resize', initDesktop._onResize);
      initDesktop._onResize = null;
    }
  }

  // ---------- MOBILE PANEL: create <767, remove >=767 ----------
  let panel = null; // only exists in mobile

  function wrapForMobile() {
    if (panel && panel.isConnected) return;
    panel = document.createElement('div');
    panel.className = 'gh-mobile-panel';
    // place wrapper where the menu currently is
    inner.insertBefore(panel, menu);
    // move nodes into it (listeners preserved)
    panel.appendChild(menu);
    panel.appendChild(actions);
  }

  function unwrapMobilePanel() {
    if (!panel || !panel.parentNode) return;
    const parent = panel.parentNode;
    // put menu back where the panel sits
    parent.insertBefore(menu, panel);
    // and actions right after menu
    parent.insertBefore(actions, menu.nextSibling);
    // remove wrapper
    panel.remove();
    panel = null;
    // reset mobile state if any
    head.classList.remove('is-open', 'nav-animating');
    document.documentElement.style.setProperty('--mobile-menu-extra', '0px');
  }

  function initMobile() {
    if (isMobileInit) return;
    isMobileInit = true;
    teardownDesktopDropdown();
    nav.innerHTML = navHTML;
    wrapForMobile();
  }

  function teardownMobile() {
    if (!isMobileInit) return;
    isMobileInit = false;
    head.classList.remove('is-open', 'nav-animating');
    unwrapMobilePanel();
  }

  // ---------- Mobile open/close (no changes except guarding for mobile) ----------
  const root = document.documentElement;
  const setHeaderExtra = (px) => {
    root.style.setProperty('--mobile-menu-extra', `${Math.max(0, Math.round(px))}px`);
  };

  let isAnimating = false;

  const burger = head.querySelector('.gh-burger');
  if (burger && !burger._accordionBound) {
    const toggleNav = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!mediaQuery.matches) return; // only act on mobile
      if (isAnimating) return;
      head.classList.contains('is-open') ? closeNav() : openNav();
    };
    burger.addEventListener('click', toggleNav);
    burger._accordionBound = toggleNav;
  }

  function openNav() {
    if (!mediaQuery.matches) return;              // guard
    if (isAnimating || head.classList.contains('is-open')) return;
    isAnimating = true;

    wrapForMobile();                               // ensure wrapper exists

    head.classList.add('is-open', 'nav-animating');

    panel.style.maxHeight = '0px';
    panel.style.opacity   = '0';

    const target = panel.scrollHeight;
    setHeaderExtra(0);

    requestAnimationFrame(() => {
      panel.style.maxHeight = `${target}px`;
      panel.style.opacity   = '1';
      setHeaderExtra(target);
    });

    const finalize = () => {
      head.classList.remove('nav-animating');
      panel.style.maxHeight = '';
      isAnimating = false;
    };

    const onEnd = (ev) => {
      if (ev.target !== panel || ev.propertyName !== 'max-height') return;
      panel.removeEventListener('transitionend', onEnd);
      clearTimeout(fallback);
      finalize();
    };
    const fallback = setTimeout(() => { panel.removeEventListener('transitionend', onEnd); finalize(); }, 450);
    panel.addEventListener('transitionend', onEnd);
  }

  function closeNav() {
    if (!mediaQuery.matches) return;               // guard
    if (isAnimating || !head.classList.contains('is-open')) return;
    isAnimating = true;

    head.classList.add('nav-animating');

    if (panel) {
      panel.style.maxHeight = `${panel.scrollHeight}px`;
      // force reflow
      // eslint-disable-next-line no-unused-expressions
      panel.offsetHeight;
      panel.style.maxHeight = '0px';
      panel.style.opacity   = '0';
    }
    setHeaderExtra(0);

    const finalize = () => {
      head.classList.remove('is-open', 'nav-animating');
      if (panel) {
        panel.style.maxHeight = '';
        panel.style.opacity   = '';
      }
      isAnimating = false;
    };

    const onEnd = (ev) => {
      if (!panel || ev.target !== panel || ev.propertyName !== 'max-height') return;
      panel.removeEventListener('transitionend', onEnd);
      clearTimeout(fallback);
      finalize();
    };

    if (panel) {
      panel.addEventListener('transitionend', onEnd);
      const fallback = setTimeout(() => { panel && panel.removeEventListener('transitionend', onEnd); finalize(); }, 450);
    } else {
      finalize();
    }
  }

  // ---------- Mode switch: ONLY add panel on mobile; ALWAYS remove on desktop ----------
  function handleResizeModeSwitch() {
    if (mediaQuery.matches) {
      teardownDesktop();
      initMobile();         // creates/keeps the wrapper
    } else {
      // moving to desktop: make sure wrapper is gone and desktop is rebuilt
      teardownMobile();     // removes wrapper + resets classes/vars
      initDesktop();
    }
  }

  handleResizeModeSwitch();

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', handleResizeModeSwitch);
  } else {
    mediaQuery.addListener(handleResizeModeSwitch);
  }
}
